/* eslint-disable tailwindcss/no-custom-classname */
import classnames from 'classnames';
import React from 'react';

import { withChakraAs } from '../../utils/withChakraAs';
import type { HeadingProps } from '../Heading/Heading';
import { Heading } from '../Heading/Heading';
import { useToastStyles } from '../Toast/Toast.context';

export type ToastTitleProps = Omit<
  HeadingProps<'div'>,
  'as' | 'size' | 'variant' | '__orbitStyleConfig'
>;

export const ToastTitle = withChakraAs<ToastTitleProps, 'div'>(
  ({ className, ...props }) => {
    const styles = useToastStyles();

    return (
      <Heading
        {...props}
        as="div"
        className={classnames('toast-title', className)}
        variant="title"
        __orbitStyleConfig={styles.title}
      />
    );
  },
);
